import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Reporte de autos',
            tblTitle: 'Reporte de autos',
            headerSearch: 'Buscar',

            headerReservationId: 'Id de reservación',
            headerCarName: 'Vehículo',
            headerUser: 'Usuario',
            headerCC: 'CC/WBS',
            headerApprover: 'Aprobador',
            headerStatus: 'Estado',
            headerStartDate: 'Fecha de inicio',
            headerEndDate: 'Fecha de fin',
        },
        en: {
            moduleTitle: 'Cars Report',
            tblTitle: 'Cars Report',
            headerSearch: 'Search',

            headerReservationId: 'Reservation id',
            headerCarName: 'Car',
            headerUser: 'User',
            headerCC: 'CC/WBS',
            headerApprover: 'Approver',
            headerStatus: 'Status',
            headerStartDate: 'Start date',
            headerEndDate: 'End date',
        }
    }
}

export default _.merge(messages, defaultMessages)